<!--
  --
  -- 摘要ページ
  --
  -->
<template>
  <c-container form wide>
    <c-book-header>ご利用人数など</c-book-header>

    <c-book-summary-sheet/>

    <c-form card-style
      v-model="valid"
      @submit="onSubmit"
    >
      <v-card-text>
        <v-row>
          <!-- 利用人数 -->
          <v-col cols="12" sm="6">
            <c-peoples-sheet v-model="peoples"/>
          </v-col>

          <!-- クーポン -->
          <v-col cols="12" sm="6">
            <c-coupon-sheet v-model="coupon"/>
          </v-col>

          <!-- 連絡事項 -->
          <v-col cols="12">
            <c-note-sheet v-model="note"/>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn
          color="primary" type="submit"
          :loading="running"
          :disabled="!valid || running"
        >
          次へ
        </v-btn>
      </v-card-actions>
    </c-form>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CBookSummarySheet from '@/pages/book/components/CBookSummarySheet'
import CForm from '@/components/CForm'
import CPeoplesSheet from './CPeoplesSheet'
import CCouponSheet from './CCouponSheet'
import CNoteSheet from './CNoteSheet'

export default {
  name: 'Remarks',
  mixins: [
    page('摘要を入力')
  ],
  components: {
    CBookHeader,
    CBookSummarySheet,
    CForm,
    CPeoplesSheet,
    CCouponSheet,
    CNoteSheet
  },

  prepare (to, from, state) {
    return {
      prepared: {
        peoples: state.getters['book/peoples'],
        coupon: state.getters['book/coupon'],
        note: state.getters['book/note']
      }
    }
  },

  props: {
    prepared: Object
  },

  data () {
    return {
      // 利用人数
      peoples: this.prepared.peoples,

      // クーポン
      coupon: this.prepared.coupon,

      // 連絡事項
      note: this.prepared.note,

      // フォームのバリデーション状態
      valid: true,

      // 処理中
      running: false
    }
  },

  methods: {
    onSubmit () {
      // book ストアに保存する
      this.commit('book/setPeoples', this.peoples)
      this.commit('book/setCoupon', this.coupon)
      this.commit('book/setNote', this.note)

      // 次のページへ
      this.goTo({ name: 'book/payment' })
    }
  }
}
</script>
